module.exports = {
  main: "main",
  lobby: "lobby",
  playClassic: "playClassic",
  playBJ: "playBJ",
  spyClassic: "spyClassic",
  reload: "reload",

  atgLobby: "atgLobby",
  atgGame: "atgGame",

  rsgLobby: "rsgLobby",
  rsgGame: "rsgGame",
  none: "none",
};
